import WebRTCIssueDetector from "webrtc-issue-detector";
import { tracker } from "../tracker/Tracker";
import { metricsManager as globalsMetricsManager } from "../Globals";
const webRTCIssueDetector = new WebRTCIssueDetector({
    getStatsInterval: 10000,
    ignoreSSRCList: [1234],
    onIssues: (issues) => {
        issues.forEach((issue) => {
            tracker.captureWebRTCIssue(issue);
            const issueData = {
                type: issue.type,
                reason: issue.reason,
                trackIdentifier: issue.trackIdentifier ?? "",
                ssrc: issue.ssrc ?? 0,
                data: issue.data ?? 0,
            };
            globalsMetricsManager.addMetric("webrtc-issue", issueData);
        });
    },
});
let startCount = 0;
export const issueDetector = {
    startRef: () => {
        startCount++;
        webRTCIssueDetector.watchNewPeerConnections();
    },
    stopRef: () => {
        if (startCount > 0) {
            startCount--;
        }
        if (startCount === 0) {
            webRTCIssueDetector.stopWatchingNewPeerConnections();
        }
    },
    isRunning: () => startCount > 0,
};
//# sourceMappingURL=WebRTCIssueDetector.js.map